import { useEffect, useRef } from "react";
/**
 * Hook to execute a callback after a delay.
 *
 * @param {Function} callback A function to execute after a delay
 * @param {Number} delay The delay in milliseconds
 * @param {Boolean} active A boolean indicating if this hook is active
 */

export default function useTimeout(callback, delay, active) {
  const savedCallback = useRef();

  function tick() {
    savedCallback.current();
  } // Remember the latest callback.


  useEffect(() => {
    if (active) {
      savedCallback.current = callback;
    }
  }, [callback, active]); // Set up the interval.

  useEffect(() => {
    if (active) {
      const id = setInterval(tick, delay);
      return () => {
        clearTimeout(id);
      };
    }
  }, [delay, active]);
}